import React from 'react';
import { Link } from 'react-router-dom';

export interface SyllabusItemProps {
  id?:number;
  title: string;
  week: string;
  content: string;
  status: string;
  class_code: string;
  subject:string;
  setSelected?:any;
}

const SyllabusItem: React.FC<SyllabusItemProps> = ({ title, week, content, status, class_code, setSelected }) => {
  return (
    <div className="card">
      <div className="card-body p-3 pb-0">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="input-block todo-inbox-check d-flex align-items-center w-50 mb-3">
            <div className="form-check form-check-md me-2">
              <input className="form-check-input" type="checkbox" />
            </div>
            <div className="strike-info">
              <h4 className="mb-1">
                {title} 
              </h4>
              <p className="mb-0">Week: {week}</p>
              <p className="mb-0">Class: {class_code}</p>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
          <div className="d-flex align-items-center flex-fill justify-content-between ms-4 mb-3">
            <div className="notes-card-body d-flex align-items-center">
              <p className="badge bg-outline-danger d-inline-flex align-items-center me-2 mb-0">
                <i className="fas fa-circle fs-6 me-1" /> {status}
              </p>
              {/* <p className="badge bg-outline-secondary mb-0"> New </p> */}
            </div>
            <div className="d-flex align-items-center">
              {/* <span className="avatar avatar-md me-2">
                <img
                  src="https://imageplaceholder.net/300"
                  alt="Img"
                  className="img-fluid rounded-circle"
                />
              </span> */}
              <Link to="#" onClick={()=>{ setSelected({title, week, content, status})}} data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu notes-menu dropdown-menu-end">
                <Link
                  to="#"
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#edit-note-units"
                >
                  <span>
                    <i data-feather="edit" />
                  </span>
                  Edit
                </Link>
                <Link
                  to="#"
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                >
                  <span>
                    <i data-feather="trash-2" />
                  </span>
                  Delete
                </Link>
                <Link to="#" className="dropdown-item">
                  <span>
                    <i data-feather="star" />
                  </span>
                  Not Important
                </Link>
                <Link
                  to="#"
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#view-note-units"
                >
                  <span>
                    <i data-feather="eye" />
                  </span>
                  View
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyllabusItem;
